import { reducerWithInitialState } from 'typescript-fsa-reducers/dist';
import { selectCurrentStudentClassroomAction } from '../actions/student-ui-actions';

export interface StudentUIState {
  selectedClass: string;
}

const INITIAL_STATE: StudentUIState = {
  selectedClass: '',
};

function selectClassReducer(
  state: StudentUIState,
  selectedClass: string
): StudentUIState {
  return { ...state, selectedClass };
}

export const studentUIReducers = reducerWithInitialState(INITIAL_STATE)
  .case(selectCurrentStudentClassroomAction, selectClassReducer)
  .build();
